import {
	Box,
	Checkbox,
	IconButton,
	Menu,
	MenuItem,
	TableCell,
	TableRow,
	Typography
} from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import React from 'react';

import { useMenu } from 'hooks';
import { properCase } from 'lib/utils';

const ReferralItem = ({
	referral,
	isSelectable,
	selectedIds = [],
	handleSelect,
	handleClick,
	handleEditClick,
	handleDeleteClick,
	...props
}) => {
	const { open, anchorEl, handleToggleMenu, handleClose } = useMenu();

	const renderMenu = () => (
		<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
			<MenuItem onClick={(e) => handleEditClick(referral, e)}>Edit</MenuItem>
			<MenuItem onClick={(e) => handleDeleteClick(referral, e)}>
				Delete
			</MenuItem>
		</Menu>
	);

	const isSelected = selectedIds.includes(referral.id);

	return (
		<TableRow
			hover
			onClick={() => handleClick(referral)}
			sx={{ cursor: 'pointer' }}
		>
			{isSelectable && (
				<TableCell>
					<Checkbox
						checked={isSelected ? true : false}
						onChange={() => handleSelect(referral)}
						name="referral"
						color="primary"
					/>
				</TableCell>
			)}
			<TableCell>
				<Typography variant="primary.text">
					{referral?.referrer?.first_name} {referral?.referrer?.last_name}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">
					{referral?.new_user?.first_name} {referral?.new_user?.last_name}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{referral.points}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">
					{properCase(referral.status)}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{referral.created_at}</Typography>
			</TableCell>
			<TableCell align="right">
				<IconButton
					onClick={(e) => {
						e.stopPropagation();
						handleToggleMenu(e);
					}}
				>
					<MoreHoriz />
				</IconButton>
				{renderMenu()}
			</TableCell>
		</TableRow>
	);
};

export default ReferralItem;
